import React from 'react';

function Contact(props) {
	return <div></div>;
}

export default Contact;
